import { RelatoriosContent } from '@/shared/components/relatorios/relatorios-content';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ORGAO_ROUTES } from '@/features/registro/orgaos/orgao.constants';

@Component({
    selector: 'app-orgao-relatorios-content',
    standalone: true,
    imports: [RouterModule, RelatoriosContent],
    template: `<app-relatorios-content [itens]="itens"></app-relatorios-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrgaoRelatoriosContent {
    /** Relatórios disponíveis (routerLink derivam de `ORGAO_ROUTES`). */
    readonly itens: MenuItem[] = [
        { label: 'Ficha Cadastral', routerLink: ORGAO_ROUTES.RELATORIOS.FICHA_CADASTRAL },
        { label: 'Composição Efetiva', routerLink: ORGAO_ROUTES.RELATORIOS.COMPOSICAO }
    ];
}
